<template>
  <div class="order-action-modals">
    <!-- 订单详情弹框 -->
    <div
      v-if="showDetailModal"
      class="modal-overlay"
      @click.self="closeDetailModal"
    >
      <div class="modal modal-order-create">
        <div class="modal-header">
          <span class="modal-title">订单详情</span>
          <span class="modal-close" @click="closeDetailModal">×</span>
        </div>
        <div class="modal-body">
          <div v-if="detailLoading" class="modal-detail-loading">
            加载详情中...
          </div>
          <template v-else>
            <div class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">门诊代号</label>
                <div class="detail-text">{{ detailDisplay.hospitalDisplay }}</div>
              </div>
              <div class="form-group">
                <label class="form-label">医生姓名</label>
                <div class="detail-text">{{ detailDisplay.doctorDisplay }}</div>
              </div>
            </div>
            <div class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">患者名字</label>
                <div class="detail-text">{{ detailDisplay.patientName }}</div>
              </div>
              <div class="form-group">
                <label class="form-label">修复牙位</label>
                <div class="detail-text">{{ detailDisplay.toothPosition }}</div>
              </div>
            </div>
            <div class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">服务项目</label>
                <div class="detail-text">{{ detailDisplay.serviceDisplay }}</div>
              </div>
              <div class="form-group">
                <label class="form-label">修复产品</label>
                <div class="detail-text">{{ detailDisplay.repairName }}</div>
              </div>
            </div>
            <div class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">预约日期</label>
                <div class="detail-text">{{ detailDisplay.appointmentDate }}</div>
              </div>
              <div class="form-group">
                <label class="form-label">预约时间</label>
                <div class="detail-text">{{ detailDisplay.timeSlotDisplay }}</div>
              </div>
            </div>
            <div class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">指派技师</label>
                <div class="detail-text">{{ detailDisplay.technicianDisplay }}</div>
              </div>
              <div class="form-group">
                <label class="form-label">数据发送邮箱</label>
                <div class="detail-text">{{ detailDisplay.email }}</div>
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">备注</label>
              <div class="detail-text detail-textarea">{{ detailDisplay.remark }}</div>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button
            class="footer-btn footer-btn-cancel"
            type="button"
            @click="closeDetailModal"
          >
            关闭
          </button>
        </div>
      </div>
    </div>

    <!-- 修改订单 / 重新预约弹框 -->
    <div
      v-if="showEditModal"
      class="modal-overlay"
      @click.self="closeEditModal"
    >
      <div class="modal modal-order-create">
        <div class="modal-header">
          <span class="modal-title">{{ editModalTitle }}</span>
          <span class="modal-close" @click="closeEditModal">×</span>
        </div>
        <div class="modal-body">
          <div v-if="editOptionsLoading" class="modal-detail-loading">
            加载订单信息中...
          </div>
          <template v-else>
            <div class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">订单编号</label>
                <div class="detail-text">{{ editForm.orderNo || "-" }}</div>
              </div>
              <div class="form-group">
                <label class="form-label">当前指派技师</label>
                <div class="detail-text">{{ editForm.currentChairDisplay || "-" }}</div>
              </div>
            </div>
            <div v-if="!isReturnEditMode" class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">患者名字</label>
                <div class="detail-text">{{ editForm.patientName || "-" }}</div>
              </div>
              <div class="form-group">
                <label class="form-label">
                  <span class="required-mark">*</span>修复牙位
                </label>
                <input
                  v-model.trim="editForm.toothPosition"
                  class="form-input"
                  placeholder="如：16, 17, 26, 27"
                />
              </div>
            </div>
            <div v-if="!isReturnEditMode" class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">
                  <span class="required-mark">*</span>服务项目
                </label>
                <select
                  v-model="editForm.projectId"
                  class="form-select"
                  @change="onEditServiceProjectChange"
                >
                  <option value="" disabled>请选择服务项目</option>
                  <option
                    v-for="item in serviceOptions"
                    :key="'edit-service-' + item.projectId"
                    :value="item.projectId"
                  >
                    {{ item.label }} (耗时：{{ item.duration }} 小时)
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label class="form-label">
                  <span class="required-mark">*</span>修复产品
                </label>
                <select
                  v-model="editForm.repairId"
                  class="form-select"
                  :class="{ 'is-field-disabled': isEditRepairSelectDisabled }"
                  :disabled="isEditRepairSelectDisabled"
                >
                  <option value="" disabled>
                    {{
                      editProjectRepairLoading
                        ? "加载关联修复产品中..."
                        : !editForm.projectId
                          ? "请先选择服务项目"
                          : editRepairOptions.length
                            ? "请选择修复产品"
                            : "暂无关联修复产品"
                    }}
                  </option>
                  <option
                    v-for="item in editRepairOptions"
                    :key="'edit-repair-' + item.repairId"
                    :value="item.repairId"
                  >
                    {{ item.repairName }}
                  </option>
                </select>
              </div>
            </div>
            <template v-if="isReturnEditMode">
              <div class="form-row form-row-2">
                <div class="form-group">
                  <label class="form-label">
                    <span class="required-mark">*</span>服务项目
                  </label>
                  <select
                    v-model="editForm.projectId"
                    class="form-select"
                    @change="onEditServiceProjectChange"
                  >
                    <option value="" disabled>请选择服务项目</option>
                    <option
                      v-for="item in serviceOptions"
                      :key="'reschedule-service-' + item.projectId"
                      :value="item.projectId"
                    >
                      {{ item.label }} (耗时：{{ item.duration }} 小时)
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label">
                    <span class="required-mark">*</span>预约日期
                  </label>
                  <el-date-picker
                    v-model="editForm.appointmentDate"
                    class="form-date-picker"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy/MM/dd"
                    format="yyyy/MM/dd"
                    :picker-options="appointmentDatePickerOptions"
                    @change="onEditAppointmentDateChange"
                  />
                </div>
              </div>
              <div class="form-row form-row-2">
                <div class="form-group">
                  <label class="form-label">
                    <span class="required-mark">*</span>预约时间
                  </label>
                  <select
                    v-model="editForm.timeSlot"
                    class="form-select"
                    :class="{ 'is-field-disabled': isEditTimeSlotDisabled }"
                    :disabled="isEditTimeSlotDisabled"
                    @change="syncEditTechnicianSelectState"
                  >
                    <option value="" disabled>
                      {{ isEditTimeSlotDisabled ? "请先选择预约日期" : "请选择预约时间" }}
                    </option>
                    <option
                      v-for="item in timeSlotOptions"
                      :key="'reschedule-slot-' + item.value"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label">指派技师</label>
                  <select
                    v-model="editForm.chairId"
                    class="form-select"
                    :class="{ 'is-field-disabled': isEditTechnicianSelectDisabled }"
                    :disabled="isEditTechnicianSelectDisabled"
                  >
                    <option value="">
                      {{
                        editChairListLoading
                          ? "加载可用技师中..."
                          : canEditSelectTechnician
                            ? "-- 自动匹配 --"
                            : !editForm.timeSlot
                              ? "请先选择预约时间"
                              : "请先完成前置选择"
                      }}
                    </option>
                    <option
                      v-for="item in editTechnicianOptions"
                      :key="'reschedule-chair-' + item.chairId"
                      :value="item.chairId"
                    >
                      {{ item.label }}({{ item.workerId }})
                    </option>
                  </select>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="form-row form-row-2">
                <div class="form-group">
                  <label class="form-label">
                    <span class="required-mark">*</span>预约日期
                  </label>
                  <el-date-picker
                    v-model="editForm.appointmentDate"
                    class="form-date-picker"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy/MM/dd"
                    format="yyyy/MM/dd"
                    :picker-options="appointmentDatePickerOptions"
                    @change="onEditAppointmentDateChange"
                  />
                </div>
                <div class="form-group">
                  <label class="form-label">
                    <span class="required-mark">*</span>预约时间
                  </label>
                  <select
                    v-model="editForm.timeSlot"
                    class="form-select"
                    :class="{ 'is-field-disabled': isEditTimeSlotDisabled }"
                    :disabled="isEditTimeSlotDisabled"
                    @change="syncEditTechnicianSelectState"
                  >
                    <option value="" disabled>
                      {{ isEditTimeSlotDisabled ? "请先选择预约日期" : "请选择预约时间" }}
                    </option>
                    <option
                      v-for="item in timeSlotOptions"
                      :key="'edit-slot-' + item.value"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-row form-row-2">
                <div class="form-group">
                  <label class="form-label">指派技师</label>
                  <select
                    v-model="editForm.chairId"
                    class="form-select"
                    :class="{ 'is-field-disabled': isEditTechnicianSelectDisabled }"
                    :disabled="isEditTechnicianSelectDisabled"
                  >
                    <option value="">
                      {{
                        editChairListLoading
                          ? "加载可用技师中..."
                          : canEditSelectTechnician
                            ? "-- 自动匹配 --"
                            : !editForm.timeSlot
                              ? "请先选择预约时间"
                              : "请先完成前置选择"
                      }}
                    </option>
                    <option
                      v-for="item in editTechnicianOptions"
                      :key="'edit-chair-' + item.chairId"
                      :value="item.chairId"
                    >
                      {{ item.label }}({{ item.workerId }})
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label">数据发送邮箱</label>
                  <input
                    v-model.trim="editForm.email"
                    class="form-input"
                    type="email"
                    placeholder="example@clinic.com"
                  />
                </div>
              </div>
            </template>
            <div v-if="!isReturnEditMode" class="form-group">
              <label class="form-label">备注</label>
              <textarea
                v-model.trim="editForm.remark"
                class="form-textarea"
                rows="3"
                placeholder="患者情况说明、特殊需求等..."
              ></textarea>
            </div>
            <div v-if="isReturnEditMode" class="form-group">
              <label class="form-label">退单原因</label>
              <div class="detail-text">{{ editForm.cancelReason || "-" }}</div>
            </div>
            <div v-if="isReturnEditMode" class="form-group">
              <label class="form-label">退单原因分析</label>
              <div class="detail-text detail-textarea">{{ editForm.cancelReasonDetail || "-" }}</div>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button
            class="footer-btn footer-btn-cancel"
            type="button"
            @click="closeEditModal"
          >
            取消
          </button>
          <button
            class="footer-btn footer-btn-save"
            type="button"
            :disabled="savingEdit || editOptionsLoading"
            @click="submitEditOrder"
          >
            {{ savingEdit ? "提交中..." : editModalSaveText }}
          </button>
        </div>
      </div>
    </div>

    <!-- 申请退单弹框 -->
    <div
      v-if="showApplyReturnModal"
      class="modal-overlay"
      @click.self="closeApplyReturnModal"
    >
      <div class="modal modal-order-create">
        <div class="modal-header">
          <span class="modal-title">申请退单</span>
          <span class="modal-close" @click="closeApplyReturnModal">×</span>
        </div>
        <div class="modal-body">
          <div v-if="applyReturnLoading" class="modal-detail-loading">
            加载订单信息中...
          </div>
          <template v-else>
            <div class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">订单编号</label>
                <div class="detail-text">{{ applyReturnDisplay.orderNo }}</div>
              </div>
              <div class="form-group">
                <label class="form-label">当前技师</label>
                <div class="detail-text">{{ applyReturnDisplay.currentChairDisplay }}</div>
              </div>
            </div>
            <div class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">服务项目</label>
                <div class="detail-text">{{ applyReturnDisplay.serviceDisplay }}</div>
              </div>
              <div class="form-group">
                <label class="form-label">修复产品</label>
                <div class="detail-text">{{ applyReturnDisplay.repairName }}</div>
              </div>
            </div>
            <div class="form-row form-row-2">
              <div class="form-group">
                <label class="form-label">预约日期</label>
                <div class="detail-text">{{ applyReturnDisplay.appointmentDate }}</div>
              </div>
              <div class="form-group">
                <label class="form-label">预约时间</label>
                <div class="detail-text">{{ applyReturnDisplay.timeSlotDisplay }}</div>
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">
                <span class="required-mark">*</span>退单原因
              </label>
              <input
                v-model.trim="applyReturnForm.cancelReason"
                class="form-input"
                placeholder="如：设备故障、技师请假、客户改期"
              />
            </div>
            <div class="form-group">
              <label class="form-label">
                <span class="required-mark">*</span>退单原因详情说明
              </label>
              <textarea
                v-model.trim="applyReturnForm.cancelReasonDetail"
                class="form-textarea"
                rows="3"
                placeholder="请填写退单原因详情说明"
              ></textarea>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button
            class="footer-btn footer-btn-cancel"
            type="button"
            @click="closeApplyReturnModal"
          >
            取消
          </button>
          <button
            class="footer-btn footer-btn-save"
            type="button"
            :disabled="savingApplyReturn || applyReturnLoading"
            @click="submitApplyReturn"
          >
            {{ savingApplyReturn ? "提交中..." : "提交申请" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProject, listProjectsWithDevices } from "@/api/device";
import {
  applyReturnOrder,
  confirmOrder,
  confirmReturnOrder,
  fetchChairList as fetchChairListApi,
  getOrderDetail,
  rescheduleOrder,
  updateOrder,
} from "@/api/order";
import { listAllRepairs } from "@/api/repair";

const SUCCESS_CODE = 20000;

const TIME_SLOT_OPTIONS = [
  { value: "am", label: "上午 08:00-12:00" },
  { value: "pm", label: "下午 14:00-18:00" },
  { value: "eve", label: "全天 08:00-18:00" },
];

function createEmptyDetailDisplay() {
  return {
    hospitalDisplay: "-",
    doctorDisplay: "-",
    patientName: "-",
    toothPosition: "-",
    serviceDisplay: "-",
    repairName: "-",
    appointmentDate: "-",
    timeSlotDisplay: "-",
    technicianDisplay: "-",
    email: "-",
    remark: "-",
  };
}

function createEmptyEditForm() {
  return {
    orderId: "",
    orderNo: "",
    currentChairDisplay: "",
    hospitalId: "",
    hospitalCode: "",
    hospitalName: "",
    doctorId: "",
    doctorName: "",
    patientName: "",
    toothPosition: "",
    repairId: "",
    repairName: "",
    projectId: "",
    appointmentDate: "",
    timeSlot: "",
    chairId: "",
    email: "",
    remark: "",
    cancelReason: "",
    cancelReasonDetail: "",
  };
}

function createEmptyApplyReturnDisplay() {
  return {
    orderNo: "-",
    currentChairDisplay: "-",
    serviceDisplay: "-",
    repairName: "-",
    appointmentDate: "-",
    timeSlotDisplay: "-",
  };
}

function createEmptyApplyReturnForm() {
  return {
    cancelReason: "",
    cancelReasonDetail: "",
  };
}

export default {
  name: "OrderActionModals",
  data() {
    return {
      showDetailModal: false,
      detailLoading: false,
      detailDisplay: createEmptyDetailDisplay(),
      showEditModal: false,
      editOptionsLoading: false,
      savingEdit: false,
      editForm: createEmptyEditForm(),
      editRepairOptions: [],
      editProjectRepairLoading: false,
      editTechnicianOptions: [],
      editChairListLoading: false,
      editModalMode: "edit",
      showApplyReturnModal: false,
      applyReturnLoading: false,
      savingApplyReturn: false,
      applyReturnOrderId: "",
      applyReturnDisplay: createEmptyApplyReturnDisplay(),
      applyReturnForm: createEmptyApplyReturnForm(),
      allRepairCatalog: [],
      serviceOptions: [],
      timeSlotOptions: TIME_SLOT_OPTIONS,
    };
  },
  computed: {
    isReturnEditMode() {
      return this.editModalMode === "reschedule";
    },
    editModalTitle() {
      return this.isReturnEditMode ? "重新预约" : "修改订单";
    },
    editModalSaveText() {
      return this.isReturnEditMode ? "保存预约" : "保存修改";
    },
    appointmentDatePickerOptions() {
      return {
        disabledDate: (date) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return date.getTime() < today.getTime();
        },
      };
    },
    isEditRepairSelectDisabled() {
      return !this.editForm.projectId || this.editProjectRepairLoading;
    },
    isEditTimeSlotDisabled() {
      return !this.editForm.appointmentDate;
    },
    canEditSelectTechnician() {
      return Boolean(
        this.editForm.hospitalId &&
          this.editForm.projectId &&
          this.editForm.appointmentDate &&
          this.editForm.timeSlot
      );
    },
    isEditTechnicianSelectDisabled() {
      return !this.canEditSelectTechnician || this.editChairListLoading;
    },
  },
  methods: {
    viewDetail(item) {
      return this.handleViewDetail(item);
    },
    confirmOrderAction(item) {
      return this.handleConfirmOrder(item);
    },
    editOrder(item) {
      return this.openEditModal(item, "edit");
    },
    applyReturn(item) {
      return this.handleApplyReturn(item);
    },
    confirmReturnAction(item) {
      return this.handleConfirmReturn(item);
    },
    rescheduleOrderAction(item) {
      return this.openEditModal(item, "reschedule");
    },
    showMessage(type, text) {
      this.$message({ message: text, type });
    },
    isBizError(res) {
      return res && res.code != null && Number(res.code) !== SUCCESS_CODE;
    },
    resolveListPayload(data) {
      if (Array.isArray(data)) {
        return { list: data, total: data.length };
      }
      if (!data || typeof data !== "object") {
        return { list: [], total: 0 };
      }
      const list = data.list || data.records || data.rows || [];
      const total = Number(data.total ?? list.length) || 0;
      return {
        list: Array.isArray(list) ? list : [],
        total,
      };
    },
    mapServiceOptions(list) {
      if (!Array.isArray(list)) return [];
      return list
        .map((item) => {
          const projectId = String(item.id ?? item.projectId ?? "").trim();
          const code = String(item.code ?? "").trim();
          const name = String(item.name ?? "").trim();
          if (!projectId) return null;
          const label = code && name ? `${code} ${name}` : code || name || projectId;
          const duration = item.duration;
          return { projectId, code, name, label, duration };
        })
        .filter(Boolean);
    },
    mapRepairOptions(list) {
      return (list || [])
        .map((item) => this.normalizeRepairOption(item))
        .filter(Boolean);
    },
    normalizeRepairOption(repair) {
      if (!repair) return null;
      if (typeof repair === "string" || typeof repair === "number") {
        const repairId = String(repair).trim();
        if (!repairId) return null;
        const matched = this.allRepairCatalog.find(
          (item) => String(item.repairId) === repairId
        );
        return matched || { repairId, repairName: repairId };
      }
      const repairId = String(repair.repairId ?? repair.id ?? "").trim();
      const repairName = String(repair.repairName ?? repair.name ?? "").trim();
      if (!repairId) return null;
      return { repairId, repairName: repairName || repairId };
    },
    extractProjectRepairIds(repairPayload) {
      if (!Array.isArray(repairPayload)) return [];
      return repairPayload
        .map((item) => {
          if (typeof item === "string" || typeof item === "number") {
            return String(item).trim();
          }
          return String(item.repairId ?? item.id ?? "").trim();
        })
        .filter(Boolean);
    },
    matchRepairIdsToCatalog(repairIds) {
      const ids = (repairIds || []).map((id) => String(id).trim()).filter(Boolean);
      return ids
        .map((repairId) => {
          const matched = this.allRepairCatalog.find(
            (item) => String(item.repairId) === repairId
          );
          if (matched) return matched;
          const fromPayload = this.normalizeRepairOption({ repairId });
          return fromPayload;
        })
        .filter(Boolean);
    },
    mapAvailableChairOptions(list) {
      return (list || [])
        .map((item) => {
          const chairId = String(item.chairId ?? item.id ?? "").trim();
          const realName = String(
            item.realName ?? item.name ?? item.workerName ?? ""
          ).trim();
          const workerId = String(item.workerId ?? "").trim();
          if (!chairId) return null;
          return {
            chairId,
            realName,
            label: realName || chairId,
            workerId,
          };
        })
        .filter(Boolean);
    },
    async fetchOrderFormOptions() {
      const [repairRes, serviceRes] = await Promise.all([
        listAllRepairs(),
        listProjectsWithDevices(),
      ]);

      if (this.isBizError(repairRes)) {
        this.showMessage("error", repairRes.msg || "修复产品加载失败");
        this.allRepairCatalog = [];
      } else {
        this.allRepairCatalog = this.mapRepairOptions(
          this.resolveListPayload(repairRes && repairRes.data).list
        );
      }

      if (this.isBizError(serviceRes)) {
        this.showMessage("error", serviceRes.msg || "服务项目加载失败");
        this.serviceOptions = [];
      } else {
        this.serviceOptions = this.mapServiceOptions(
          this.resolveListPayload(serviceRes && serviceRes.data).list
        );
      }
    },
    findServiceOption(projectId) {
      const id = String(projectId || "").trim();
      return (this.serviceOptions || []).find(
        (item) => String(item.projectId) === id
      );
    },
    formatTimeSlotLabel(timeSlot) {
      const value = String(timeSlot || "").trim();
      const matched = TIME_SLOT_OPTIONS.find((item) => item.value === value);
      return matched ? matched.label : value || "-";
    },
    displayText(value) {
      const text = String(value ?? "").trim();
      return text || "-";
    },
    resolveCurrentChairDisplay(data) {
      if (!data || typeof data !== "object") return "-";
      const chairName = String(data.chairName ?? "").trim();
      const workerId = String(data.workerId ?? "").trim();
      const chairId = String(data.chairId ?? "").trim();
      if (chairName && workerId) {
        return `${chairName}(${workerId})`;
      }
      if (chairName) return chairName;
      if (workerId) return workerId;
      if (chairId) return chairId;
      return "-";
    },
    resetEditForm() {
      this.editForm = createEmptyEditForm();
      this.editRepairOptions = [];
      this.editProjectRepairLoading = false;
      this.editTechnicianOptions = [];
      this.editChairListLoading = false;
    },
    closeEditModal() {
      this.showEditModal = false;
      this.editModalMode = "edit";
      this.resetEditForm();
    },
    findEditRepairOption(repairId) {
      const id = String(repairId || "").trim();
      return (this.editRepairOptions || []).find(
        (item) => String(item.repairId) === id
      );
    },
    findEditTechnicianOption(chairId) {
      const id = String(chairId || "").trim();
      if (!id) return null;
      return (this.editTechnicianOptions || []).find(
        (item) => String(item.chairId) === id
      );
    },
    resolveRepairIdFromDetail(data, repairOptions) {
      const options = repairOptions || [];
      const repairId = String(data.repairId ?? "").trim();
      if (repairId && options.some((item) => String(item.repairId) === repairId)) {
        return repairId;
      }
      const repairName = String(data.repairName ?? "").trim();
      if (!repairName) return repairId;
      const matched = options.find(
        (item) => String(item.repairName) === repairName
      );
      if (matched) return matched.repairId;
      if (repairId) return repairId;
      return repairName;
    },
    resetEditProjectRepairOptions() {
      this.editForm.repairId = "";
      this.editRepairOptions = [];
      this.syncEditTechnicianSelectState();
    },
    onEditAppointmentDateChange(value) {
      if (!value) {
        this.editForm.timeSlot = "";
      }
      this.syncEditTechnicianSelectState();
    },
    syncEditTechnicianSelectState() {
      if (!this.canEditSelectTechnician) {
        this.editForm.chairId = "";
        this.editTechnicianOptions = [];
        return;
      }
      this.editForm.chairId = "";
      this.fetchEditChairList();
    },
    onEditServiceProjectChange() {
      if (this.isReturnEditMode) {
        this.syncEditTechnicianSelectState();
        return;
      }
      this.resetEditProjectRepairOptions();
      if (!this.editForm.projectId) return;
      this.fetchEditProjectRepairOptions(this.editForm.projectId);
    },
    async fetchEditProjectRepairOptions(projectId) {
      const id = String(projectId || "").trim();
      if (!id) {
        this.editRepairOptions = [];
        return;
      }
      this.editProjectRepairLoading = true;
      try {
        const res = await getProject({ projectId: id });
        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "服务项目关联修复产品加载失败");
          this.editRepairOptions = [];
          return;
        }
        const detail = res && res.data != null ? res.data : res;
        const repairIds = this.extractProjectRepairIds(detail.repairIds);
        if (repairIds.length) {
          this.editRepairOptions = this.matchRepairIdsToCatalog(repairIds);
          return;
        }
        const repairList = this.resolveListPayload(detail).list;
        this.editRepairOptions = repairList
          .map((item) => this.normalizeRepairOption(item))
          .filter(Boolean);
      } catch (error) {
        const msg =
          (error && error.msg) ||
          error.message ||
          "服务项目关联修复产品加载失败，请稍后重试";
        this.showMessage("error", msg);
        this.editRepairOptions = [];
      } finally {
        this.editProjectRepairLoading = false;
      }
    },
    async fetchEditChairList({ preserveChairId = false } = {}) {
      const { hospitalId, projectId, appointmentDate, timeSlot } = this.editForm;
      if (!hospitalId || !projectId || !appointmentDate || !timeSlot) {
        this.editTechnicianOptions = [];
        return;
      }
      const previousChairId = preserveChairId
        ? String(this.editForm.chairId || "").trim()
        : "";
      this.editChairListLoading = true;
      try {
        const res = await fetchChairListApi({
          hospitalId,
          projectId,
          appointmentDate,
          timeSlot,
        });
        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "可用技师加载失败");
          this.editTechnicianOptions = [];
          return;
        }
        const payload = this.resolveListPayload(res && res.data);
        this.editTechnicianOptions = this.mapAvailableChairOptions(payload.list);
        if (
          previousChairId &&
          this.editTechnicianOptions.some(
            (item) => String(item.chairId) === previousChairId
          )
        ) {
          this.editForm.chairId = previousChairId;
        }
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "可用技师加载失败，请稍后重试";
        this.showMessage("error", msg);
        this.editTechnicianOptions = [];
      } finally {
        this.editChairListLoading = false;
      }
    },
    async applyEditFormFromDetail(data) {
      if (!data || typeof data !== "object") return;

      this.editForm.orderId = String(data.orderId ?? "").trim();
      this.editForm.orderNo = String(
        data.orderNo ?? data.orderCode ?? this.editForm.orderId
      ).trim();
      this.editForm.currentChairDisplay = this.resolveCurrentChairDisplay(data);
      this.editForm.hospitalId = String(data.hospitalId ?? "").trim();
      this.editForm.hospitalCode = String(data.hospitalCode ?? "").trim();
      this.editForm.hospitalName = String(data.hospitalName ?? "").trim();
      this.editForm.doctorId = String(data.doctorId ?? "").trim();
      this.editForm.doctorName = String(data.doctorName ?? "").trim();
      this.editForm.patientName = String(data.patientName ?? "").trim();
      this.editForm.toothPosition = String(data.toothPosition ?? "").trim();
      this.editForm.repairName = String(data.repairName ?? "").trim();
      this.editForm.projectId = String(data.projectId ?? "").trim();
      this.editForm.appointmentDate = String(data.appointmentDate ?? "").trim();
      this.editForm.timeSlot = String(data.timeSlot ?? "").trim();
      this.editForm.chairId = String(data.chairId ?? "").trim();
      this.editForm.email = String(data.email ?? "").trim();
      this.editForm.remark = String(data.remark ?? "").trim();
      this.editForm.cancelReason = String(
        data.cancelReason ?? data.returnReason ?? ""
      ).trim();
      this.editForm.cancelReasonDetail = String(
        data.cancelReasonDetail ?? data.returnReasonDetail ?? ""
      ).trim();

      if (this.editForm.projectId && !this.isReturnEditMode) {
        await this.fetchEditProjectRepairOptions(this.editForm.projectId);
        this.editForm.repairId = this.resolveRepairIdFromDetail(
          data,
          this.editRepairOptions
        );
      } else if (this.isReturnEditMode) {
        this.editForm.repairId = String(data.repairId ?? "").trim();
      }

      if (this.canEditSelectTechnician) {
        await this.fetchEditChairList({ preserveChairId: true });
      }
    },
    async openEditModal(item, mode) {
      const orderId = String(item.orderId ?? item.raw?.orderId ?? "").trim();
      if (!orderId) {
        this.showMessage("warning", "缺少订单ID，无法修改");
        return;
      }

      this.editModalMode = mode === "reschedule" ? "reschedule" : "edit";
      this.showEditModal = true;
      this.editOptionsLoading = true;
      this.resetEditForm();

      try {
        await this.fetchOrderFormOptions();
        const res = await getOrderDetail({ orderId });
        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "获取订单详情失败");
          this.closeEditModal();
          return;
        }
        await this.applyEditFormFromDetail(res.data);
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "加载订单信息失败，请稍后重试";
        this.showMessage("error", msg);
        this.closeEditModal();
      } finally {
        this.editOptionsLoading = false;
      }
    },
    validateEditForm() {
      const form = this.editForm;
      if (!form.orderId) {
        this.showMessage("warning", "缺少订单ID");
        return false;
      }
      if (!this.isReturnEditMode && !form.toothPosition) {
        this.showMessage("warning", "请输入修复牙位");
        return false;
      }
      if (!form.projectId) {
        this.showMessage("warning", "请选择服务项目");
        return false;
      }
      if (!this.isReturnEditMode && !form.repairId) {
        this.showMessage("warning", "请选择修复产品");
        return false;
      }
      if (!form.appointmentDate) {
        this.showMessage("warning", "请选择预约日期");
        return false;
      }
      if (!form.timeSlot) {
        this.showMessage("warning", "请选择预约时间");
        return false;
      }
      if (
        !this.isReturnEditMode &&
        form.email &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)
      ) {
        this.showMessage("warning", "请输入正确的邮箱格式");
        return false;
      }
      return true;
    },
    buildUpdateOrderPayload() {
      const form = this.editForm;
      const service = this.findServiceOption(form.projectId) || {};
      const repair = this.findEditRepairOption(form.repairId) || {};
      const chair = this.findEditTechnicianOption(form.chairId) || {};

      return {
        orderId: form.orderId,
        hospitalId: form.hospitalId,
        hospitalCode: form.hospitalCode || "",
        hospitalName: form.hospitalName || "",
        doctorId: form.doctorId,
        doctorName: form.doctorName || "",
        chairId: form.chairId,
        chairName: chair.realName || "",
        workerId: chair.workerId || "",
        patientName: form.patientName,
        projectId: form.projectId,
        projectCode: service.code || "",
        projectName: service.name || "",
        repairName: repair.repairName || form.repairName || "",
        toothPosition: form.toothPosition,
        appointmentDate: form.appointmentDate,
        timeSlot: form.timeSlot,
        email: form.email,
        remark: form.remark,
      };
    },
    buildRescheduleOrderPayload() {
      const form = this.editForm;
      const service = this.findServiceOption(form.projectId) || {};
      const chair = this.findEditTechnicianOption(form.chairId) || {};

      return {
        orderId: form.orderId,
        chairId: form.chairId,
        chairName: chair.realName || "",
        workerId: chair.workerId || "",
        projectId: form.projectId,
        projectCode: service.code || "",
        projectName: service.name || "",
        appointmentDate: form.appointmentDate,
        timeSlot: form.timeSlot,
      };
    },
    async submitEditOrder() {
      if (!this.validateEditForm()) return;

      this.savingEdit = true;
      try {
        const isReschedule = this.isReturnEditMode;
        const res = isReschedule
          ? await rescheduleOrder(this.buildRescheduleOrderPayload())
          : await updateOrder(this.buildUpdateOrderPayload());
        if (this.isBizError(res)) {
          this.showMessage(
            "error",
            res.msg || (isReschedule ? "重新预约失败" : "修改订单失败")
          );
          return;
        }
        this.showMessage(
          "success",
          (res && res.msg) || (isReschedule ? "重新预约成功" : "修改订单成功")
        );
        this.closeEditModal();
        this.$emit("success");
      } catch (error) {
        const isReschedule = this.isReturnEditMode;
        const msg =
          (error && error.msg) ||
          error.message ||
          (isReschedule ? "重新预约失败，请稍后重试" : "修改订单失败，请稍后重试");
        this.showMessage("error", msg);
      } finally {
        this.savingEdit = false;
      }
    },
    mapOrderDetailDisplay(data) {
      if (!data || typeof data !== "object") {
        return createEmptyDetailDisplay();
      }

      const hospitalCode = this.displayText(data.hospitalCode);
      const hospitalName = this.displayText(data.hospitalName);
      const hospitalDisplay =
        hospitalCode !== "-" && hospitalName !== "-"
          ? `${hospitalCode} · ${hospitalName}`
          : hospitalCode !== "-"
            ? hospitalCode
            : hospitalName;

      const doctorName = this.displayText(data.doctorName);
      const doctorPhone = String(data.doctorPhone ?? data.phone ?? "").trim();
      const doctorDisplay =
        doctorName !== "-" && doctorPhone
          ? `${doctorName}(${doctorPhone})`
          : doctorName;

      const serviceDisplay = this.buildServiceDisplay(data);
      const technicianDisplay =
        String(data.chairName ?? "").trim() ||
        String(data.workerId ?? "").trim() ||
        String(data.chairId ?? "").trim()
          ? this.resolveCurrentChairDisplay(data)
          : "自动匹配";

      return {
        hospitalDisplay,
        doctorDisplay,
        patientName: this.displayText(data.patientName),
        toothPosition: this.displayText(data.toothPosition),
        serviceDisplay,
        repairName: this.displayText(data.repairName),
        appointmentDate: this.displayText(data.appointmentDate),
        timeSlotDisplay: this.formatTimeSlotLabel(data.timeSlot),
        technicianDisplay,
        email: this.displayText(data.email),
        remark: this.displayText(data.remark),
      };
    },
    buildServiceDisplay(data) {
      if (!data || typeof data !== "object") return "-";
      const projectCode = this.displayText(data.projectCode);
      const projectName = this.displayText(data.projectName);
      const duration = data.projectDuration ?? data.duration;
      const durationText =
        duration != null && duration !== "" && !Number.isNaN(Number(duration))
          ? ` (耗时：${duration} 小时)`
          : "";
      if (projectCode !== "-" && projectName !== "-") {
        return `${projectCode} ${projectName}${durationText}`;
      }
      if (projectCode !== "-") {
        return `${projectCode}${durationText}`;
      }
      if (projectName !== "-") {
        return `${projectName}${durationText}`;
      }
      return "-";
    },
    mapApplyReturnDisplay(data) {
      if (!data || typeof data !== "object") {
        return createEmptyApplyReturnDisplay();
      }
      const chairDisplay = this.resolveCurrentChairDisplay(data);
      return {
        orderNo: this.displayText(data.orderNo ?? data.orderCode ?? data.orderId),
        currentChairDisplay: chairDisplay === "-" ? "自动匹配" : chairDisplay,
        serviceDisplay: this.buildServiceDisplay(data),
        repairName: this.displayText(data.repairName),
        appointmentDate: this.displayText(data.appointmentDate),
        timeSlotDisplay: this.formatTimeSlotLabel(data.timeSlot),
      };
    },
    resetApplyReturnForm() {
      this.applyReturnOrderId = "";
      this.applyReturnDisplay = createEmptyApplyReturnDisplay();
      this.applyReturnForm = createEmptyApplyReturnForm();
    },
    closeApplyReturnModal() {
      this.showApplyReturnModal = false;
      this.applyReturnLoading = false;
      this.resetApplyReturnForm();
    },
    async handleApplyReturn(item) {
      const orderId = String(item.orderId ?? item.raw?.orderId ?? "").trim();
      if (!orderId) {
        this.showMessage("warning", "缺少订单ID，无法申请退单");
        return;
      }

      this.showApplyReturnModal = true;
      this.applyReturnLoading = true;
      this.resetApplyReturnForm();
      this.applyReturnOrderId = orderId;

      try {
        const res = await getOrderDetail({ orderId });
        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "获取订单详情失败");
          this.closeApplyReturnModal();
          return;
        }
        this.applyReturnDisplay = this.mapApplyReturnDisplay(res.data);
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "获取订单详情失败，请稍后重试";
        this.showMessage("error", msg);
        this.closeApplyReturnModal();
      } finally {
        this.applyReturnLoading = false;
      }
    },
    validateApplyReturnForm() {
      if (!this.applyReturnOrderId) {
        this.showMessage("warning", "缺少订单ID");
        return false;
      }
      if (!this.applyReturnForm.cancelReason) {
        this.showMessage("warning", "请填写退单原因");
        return false;
      }
      if (!this.applyReturnForm.cancelReasonDetail) {
        this.showMessage("warning", "请填写退单原因详情说明");
        return false;
      }
      return true;
    },
    async submitApplyReturn() {
      if (!this.validateApplyReturnForm()) return;

      this.savingApplyReturn = true;
      try {
        const res = await applyReturnOrder({
          orderId: this.applyReturnOrderId,
          cancelReason: this.applyReturnForm.cancelReason,
          cancelReasonDetail: this.applyReturnForm.cancelReasonDetail,
        });
        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "申请退单失败");
          return;
        }
        this.showMessage("success", (res && res.msg) || "申请退单成功");
        this.closeApplyReturnModal();
        this.$emit("success");
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "申请退单失败，请稍后重试";
        this.showMessage("error", msg);
      } finally {
        this.savingApplyReturn = false;
      }
    },
    closeDetailModal() {
      this.showDetailModal = false;
      this.detailLoading = false;
      this.detailDisplay = createEmptyDetailDisplay();
    },
    async handleViewDetail(item) {
      const orderId = String(item.orderId ?? item.raw?.orderId ?? "").trim();
      if (!orderId) {
        this.showMessage("warning", "缺少订单ID，无法查看详情");
        return;
      }

      this.showDetailModal = true;
      this.detailLoading = true;
      this.detailDisplay = createEmptyDetailDisplay();

      try {
        const res = await getOrderDetail({ orderId });
        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "获取订单详情失败");
          this.closeDetailModal();
          return;
        }
        this.detailDisplay = this.mapOrderDetailDisplay(res.data);
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "获取订单详情失败，请稍后重试";
        this.showMessage("error", msg);
        this.closeDetailModal();
      } finally {
        this.detailLoading = false;
      }
    },
    async handleConfirmReturn(item) {
      const orderId = String(item.orderId ?? item.raw?.orderId ?? "").trim();
      if (!orderId) {
        this.showMessage("warning", "缺少订单ID，无法确认退单");
        return;
      }

      try {
        const res = await confirmReturnOrder({ orderId });
        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "确认退单失败");
          return;
        }
        this.showMessage("success", (res && res.msg) || "确认退单成功");
        this.$emit("success");
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "确认退单失败，请稍后重试";
        this.showMessage("error", msg);
      }
    },
    async handleConfirmOrder(item) {
      const orderId = String(item.orderId ?? item.raw?.orderId ?? "").trim();
      if (!orderId) {
        this.showMessage("warning", "缺少订单ID，无法确认预约");
        return;
      }

      try {
        const res = await confirmOrder({ orderId });
        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "确认预约失败");
          return;
        }
        this.showMessage("success", (res && res.msg) || "确认预约成功");
        this.$emit("success");
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "确认预约失败，请稍后重试";
        this.showMessage("error", msg);
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
}

.modal-order-create {
  width: 800px;
  max-width: calc(100% - 32px);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.modal-close {
  cursor: pointer;
  font-size: 20px;
  color: #999;
  line-height: 1;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.modal-detail-loading {
  padding: 32px 0;
  text-align: center;
  color: #666;
  font-size: 14px;
}

.form-row {
  display: flex;
  gap: 16px;
}

.form-row-2 .form-group {
  flex: 1;
  min-width: 0;
}

.form-group {
  margin-bottom: 16px;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.required-mark {
  color: #ff4d4f;
  margin-right: 4px;
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  color: #333;
  background: #fff;
}

.form-select {
  height: 36px;
  cursor: pointer;
}

.form-select:disabled,
.form-select.is-field-disabled {
  background: #f5f5f5;
  color: #bfbfbf;
  cursor: not-allowed;
  border-color: #d9d9d9;
  box-shadow: none;
}

.form-input:disabled {
  background: #f5f5f5;
  color: #bfbfbf;
  cursor: not-allowed;
  border-color: #d9d9d9;
  box-shadow: none;
}

.detail-text {
  width: 100%;
  min-height: 36px;
  line-height: 36px;
  padding: 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  color: #333;
  background: #f5f5f5;
  word-break: break-all;
}

.detail-textarea {
  min-height: 80px;
  line-height: 1.5;
  padding: 8px 12px;
  white-space: pre-wrap;
}

.form-textarea {
  resize: vertical;
  min-height: 80px;
  line-height: 1.5;
  font-family: inherit;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}

.form-date-picker {
  width: 100%;
}

.form-date-picker >>> .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
}

.modal-footer {
  padding: 12px 20px 16px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-shrink: 0;
}

.footer-btn {
  min-width: 72px;
  height: 32px;
  padding: 0 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.footer-btn-cancel {
  background: #fff;
  color: #333;
  border: 1px solid #d9d9d9;
}

.footer-btn-cancel:hover {
  color: #409eff;
  border-color: #409eff;
}

.footer-btn-save {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}

.footer-btn-save:hover {
  background: #096dd9;
  border-color: #096dd9;
}

.footer-btn-save:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
